import { IApartments, IRealEstatesName, IRequestApartments } from '@interfaces/apartments/IApartments'
import { IListPaginated } from '@interfaces/api/IRequestsReturn'
import { IMessage } from '@interfaces/iMessage'
import { REAL_ESTATE_TYPE } from '@interfaces/realEstates/enums/realEstateType'
import { IRealEstateSummery } from '@interfaces/realEstates/iRealEstate'
import api from '@services/api/server'
import { IParamsUrl } from '@utils/getQueryParams/getQueryParams'

export default class ApartmentService {
    public static async list(params?: IParamsUrl): Promise<IListPaginated<IApartments>> {
        return (
            await api.get<IListPaginated<IApartments>>('/real-estates/apartments', {
                params,
            })
        ).data
    }

    public static async postApartment(data: FormData): Promise<IMessage> {
        return (await api.post<IMessage>('/real-estates/apartments', data)).data
    }

    public static async update(id: number, data: FormData): Promise<IRequestApartments> {
        return (await api.put<IRequestApartments>(`/real-estates/apartments/${id}`, data)).data
    }

    public static async delete(id: number): Promise<IMessage> {
        return (await api.delete<IMessage>(`/real-estates/apartments/${id}`)).data
    }

    public static async getRealEstateSummary(types: REAL_ESTATE_TYPE[]): Promise<IRealEstatesName[]> {
        return (
            await api.get<IRealEstateSummery[]>('/real-estates/summary', {
                params: {
                    types,
                },
            })
        ).data
    }

    public static async getApartmentById(id: number): Promise<IRequestApartments> {
        return (await api.get<IRequestApartments>(`/real-estates/apartments/${id}`)).data
    }

    public static async getFileKey(id: number): Promise<string> {
        return (await api.get<string>(`/real-estates/apartments/files/${id}/download`)).data
    }
}
